module.exports = __webpack_public_path__ + "media/m6.c578d92c.mp4";